import { useQuery } from '@apollo/client'

import { useCurrentCompanyContext } from 'src/context/CurrentCompanyContext'
import { GET_COMPANY_VOE_OUTREACH_CONFIG } from 'src/graphql/companyVoEOutreachConfig.graphql'
import type { OutreachConfigLike } from 'src/lib/voe/outreachPreview'

/**
 * The current company's automated outreach configuration, or null when it
 * has none. Cached by Apollo, so every screen that asks pays for one fetch.
 */
export const useCompanyOutreachConfig = (): {
  config: OutreachConfigLike | null
  loading: boolean
} => {
  const currentCompany = useCurrentCompanyContext()
  const companyId = currentCompany?.companyId
  const { data, loading } = useQuery(GET_COMPANY_VOE_OUTREACH_CONFIG, {
    variables: { companyId },
    skip: !companyId,
  })
  return {
    config: data?.companyVoEOutreachConfig ?? null,
    loading: Boolean(companyId) && loading,
  }
}
